"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isContentUIWithResources = exports.isContentUI = exports.CanvasSaveMode = exports.ContentResponseType = exports.Resolutions = exports.ResolutionA4Portrait = exports.ResolutionA4Landscape = exports.ResolutionPortraitHalf = exports.ResolutionPortrait = exports.ResolutionLandscapeHalf = exports.ResolutionLandscape = exports.ResolutionSquare = void 0;
var ResolutionSquare;
(function (ResolutionSquare) {
    ResolutionSquare[ResolutionSquare["width"] = 1080] = "width";
    ResolutionSquare[ResolutionSquare["height"] = 1080] = "height";
})(ResolutionSquare = exports.ResolutionSquare || (exports.ResolutionSquare = {}));
var ResolutionLandscape;
(function (ResolutionLandscape) {
    ResolutionLandscape[ResolutionLandscape["width"] = 1920] = "width";
    ResolutionLandscape[ResolutionLandscape["height"] = 1080] = "height";
})(ResolutionLandscape = exports.ResolutionLandscape || (exports.ResolutionLandscape = {}));
var ResolutionLandscapeHalf;
(function (ResolutionLandscapeHalf) {
    ResolutionLandscapeHalf[ResolutionLandscapeHalf["width"] = 960] = "width";
    ResolutionLandscapeHalf[ResolutionLandscapeHalf["height"] = 1080] = "height";
})(ResolutionLandscapeHalf = exports.ResolutionLandscapeHalf || (exports.ResolutionLandscapeHalf = {}));
var ResolutionPortrait;
(function (ResolutionPortrait) {
    ResolutionPortrait[ResolutionPortrait["width"] = 1080] = "width";
    ResolutionPortrait[ResolutionPortrait["height"] = 1920] = "height";
})(ResolutionPortrait = exports.ResolutionPortrait || (exports.ResolutionPortrait = {}));
var ResolutionPortraitHalf;
(function (ResolutionPortraitHalf) {
    ResolutionPortraitHalf[ResolutionPortraitHalf["width"] = 1080] = "width";
    ResolutionPortraitHalf[ResolutionPortraitHalf["height"] = 960] = "height";
})(ResolutionPortraitHalf = exports.ResolutionPortraitHalf || (exports.ResolutionPortraitHalf = {}));
var ResolutionA4Landscape;
(function (ResolutionA4Landscape) {
    ResolutionA4Landscape[ResolutionA4Landscape["width"] = 1527] = "width";
    ResolutionA4Landscape[ResolutionA4Landscape["height"] = 1080] = "height";
})(ResolutionA4Landscape = exports.ResolutionA4Landscape || (exports.ResolutionA4Landscape = {}));
var ResolutionA4Portrait;
(function (ResolutionA4Portrait) {
    ResolutionA4Portrait[ResolutionA4Portrait["width"] = 1080] = "width";
    ResolutionA4Portrait[ResolutionA4Portrait["height"] = 1527] = "height";
})(ResolutionA4Portrait = exports.ResolutionA4Portrait || (exports.ResolutionA4Portrait = {}));
var Resolutions;
(function (Resolutions) {
    Resolutions["square"] = "square";
    Resolutions["landscape"] = "landscape";
    Resolutions["landscapeHalf"] = "landscapeHalf";
    Resolutions["portrait"] = "portrait";
    Resolutions["portraitHalf"] = "portraitHalf";
    Resolutions["a4landscape"] = "a4landscape";
    Resolutions["a4portrait"] = "a4portrait";
    Resolutions["custom"] = "custom";
})(Resolutions = exports.Resolutions || (exports.Resolutions = {}));
/**
 * Custom props for fabric objects.
 * Property name start with "c" to make it easier to know
 * what are our custom properties and not fabric's own object properties
 */
var ContentResponseType;
(function (ContentResponseType) {
    /** Response for UI with thumbnails for UI */
    ContentResponseType["ui"] = "ui";
    /** Response for UI with canvas resources such as media urls */
    ContentResponseType["uiWithResources"] = "uiWithResources";
    ContentResponseType["player"] = "player";
})(ContentResponseType = exports.ContentResponseType || (exports.ContentResponseType = {}));
var CanvasSaveMode;
(function (CanvasSaveMode) {
    CanvasSaveMode["toMemory"] = "SaveCanvasToMemory";
    CanvasSaveMode["toDB"] = "SaveCanvasToDB";
})(CanvasSaveMode = exports.CanvasSaveMode || (exports.CanvasSaveMode = {}));
exports.isContentUI = (item) => (item === null || item === void 0 ? void 0 : item.responseType) === ContentResponseType.ui;
exports.isContentUIWithResources = (item) => (item === null || item === void 0 ? void 0 : item.responseType) === ContentResponseType.uiWithResources;
//# sourceMappingURL=contents.js.map